import RemovePartnerRewardsModalContentContainer from './RemovePartnerRewardsModalContentContainer';

export default RemovePartnerRewardsModalContentContainer;
